// styles
import styles from "./Card.module.scss";

// components
import Typography from "../Typography/Typography";
import clsx from "clsx";

const Card = ({ title, text, children, className }) => {
  return (
    <div className={clsx(styles["card"], className)}>
      {title && (
        <Typography variant="headline-2" className={styles["title"]}>
          {title}
        </Typography>
      )}

      {text && <Typography>{text}</Typography>}

      <div className={styles["inner-wrapper"]}>{children}</div>
    </div>
  );
};
export default Card;
